import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

import Box from 'carbon-react/lib/components/box';
import { Menu, MenuItem } from 'carbon-react/lib/components/menu';

import { FormattedMessage, useIntl } from '@futrli/localisation';
import { LOGOUT_ROUTE } from '@futrli/auth/core/constants';
import { ROUTES } from '@futrli/shared-services';

interface Props {
  userName: string;
  showMyProfile: boolean;
}

export const ProfileMenu = ({ userName, showMyProfile }: Props) => {
  const intl = useIntl();
  const navigate = useNavigate();

  const profileLabel =
    userName ||
    intl.formatMessage({
      id: 'common.my_profile_2',
      defaultMessage: 'My profile'
    });

  const handleMyProfileClick = () => {
    navigate(ROUTES.MY_PROFILE);
  };

  return (
    <Box>
      <Menu menuType="black">
        <MenuItem submenu={profileLabel} maxWidth="350px">
          {showMyProfile && (
            <div>
              <MenuItem onClick={handleMyProfileClick}>
                <FormattedMessage id="common.my_profile_2" defaultMessage="My profile" />
              </MenuItem>
            </div>
          )}
          <div>
            <MenuItem>
              <Link to={LOGOUT_ROUTE}>
                <FormattedMessage id="common.log_out" defaultMessage="Log out" />
              </Link>
            </MenuItem>
          </div>
        </MenuItem>
      </Menu>
    </Box>
  );
};
